import { Component, Input, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Slides, AlertController, ToastController, ModalController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { EmailauthPage } from '../emailauth/emailauth';

// import * as $ from "jquery";
import { CommonmodalPage } from '../commonmodal/commonmodal';
import { AccountconfirmPage } from '../accountconfirm/accountconfirm';

/**
 * Generated class for the AccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-account',
    templateUrl: 'account.html',
})
export class AccountPage {
    @Input() data: any;
    @Input() events: any;
    @ViewChild(Slides) slides: Slides;
  
	country_list: any = [];
	branch_list: any = [];
	center_list: any = [];
	texts: any = [];
    language : string;
    
    step: any = 1;

    servermode: string;
	server_name: string = '';

	id: string;
    email: string;
    terms_site: string;
	password: string;
	confirmPassword: string;
	name: string;
	phone: string = ''; 
	country: any;
	branch: any;
	center: any;
	chucheon: string;
	huwon: string;
    my_chucheon: string;
    my_huwon: string;
    my_center: string;

    year: string = '';
    month: string = '';
    day: string = '';
    birthday: string;
    


	private readonly: boolean = false;
	private isId: boolean = true;
	private isEmailValid: boolean = true;
	private isPasswordValid: boolean = true;
    private isConfirmPasswordValid: boolean = true;
    private isNameValid: boolean = true;
    private isPhoneValid: boolean = true;
	private isCountryValid: boolean = true;
    private isChucheonValid: boolean = true;
    private isHuwonValid: boolean = true;
    private isCenterValid: boolean = true;
    private isBranchValid: boolean = true;
    private isBirthdayValid: boolean = true;
    private isBirthdayConfirmValid: boolean = true;
    // private terms: boolean = false;

    public isDisabled: boolean = true;
    public isEnabledBtn: boolean = true;
  
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private http: HttpService,
        private alertCtrl: AlertController,
        public toastCtrl: ToastController,
		public modalCtrl: ModalController,
		public viewCtrl: ViewController,
		private app: App,
    ) {
        this.my_chucheon = this.navParams.get('chucheon');
        this.my_huwon = this.navParams.get('huwon');
        // this.my_center = this.navParams.get('center');
    }

    ionViewWillEnter() {

        //// 로그인 정보를 지운다.
        //// 새로 가입하여 완료되면 자동 로그인이 된다.
        // localStorage.removeItem("loginId");
        this.language = localStorage.getItem("language");
        this.servermode = localStorage.getItem("servermode");	
		this.server_name = localStorage.getItem("server_name");
		this.texts = JSON.parse(localStorage.getItem("texts"));

		// this.slides.freeMode = true;
		this.slides.slideTo(0, 0);
        this.slides.lockSwipes(true);
        this.step = this.slides.getActiveIndex() + 1;

        localStorage.setItem("pageName", "account");

        if(this.my_chucheon) {
            this.chucheon = this.my_chucheon;
            this.huwon = this.my_huwon;
            // this.center = this.my_center;
            this.readonly = true;
        }

        this._get_texts();
        this._init();
        
    }

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).account;
    }

    keyDown(mod) {

    }

    keyUp(mod) {
        var tmps: string;

        if (mod == "year") {
            if(this.year != null || this.year != "") {
                let tmps = this.year;
                this.year = tmps.replace(/[^0-9]/g, "");
            }
        }

        if (mod == "month") {
            if(this.month != null || this.month != "") {
                let tmps = this.month;
                this.month = tmps.replace(/[^0-9]/g, "");
            }
        }

        if (mod == "day") {
            if(this.day != null || this.day != "") {
                let tmps = this.day;
                this.day = tmps.replace(/[^0-9]/g, "");
            }
        }
	}
    
    _init() {
        let body = JSON.stringify({
        language: this.language
        });
        this.http.post("common", body).then((res:any)=>{
            if(res.result=="OK"){
                if (this.readonly) {
                    this.chucheon = this.my_chucheon
                    this.huwon = this.my_huwon
                    // this.center = this.my_center
                }
                this.country_list = res.country_list;
                // this.country = this.country_list[0].code;
                this.branch_list = res.branch_list;
                // this.branch = this.branch_list[0].code;
                this.terms_site= res.terms_site;

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        });
    }    

    _register() {
        if (this._validate4()) {
            this.isEnabledBtn = false;

            let modal = this.modalCtrl.create(AccountconfirmPage, {
                id: this.id,
                chucheon: this.chucheon,
                huwon: this.huwon,
                name: this.name,
                birthday: this.birthday,
                email: this.email,
                phone: this.phone,
                country: this.country.name,
                branch: this.branch.name,
                center: this.center.name,
            });
            modal.present();

            modal.onDidDismiss( data => {
                if (data == 'ok') {
                    let body;

                    if (this.readonly) {
                        body = JSON.stringify({
                            id: this.id,
                            email: this.email.toLocaleLowerCase(),
                            language: this.language, 
                            password: this.password,
                            name: this.name,
                            birthday: this.birthday,
                            phone: this.phone, 
                            country: this.country.code,
                            chucheon: this.chucheon,
                            huwon: this.huwon,
                            branch: this.branch.code,
                            center: this.center.code,
                            sub: "Y"
                        });
                    } else {
                        body = JSON.stringify({
                            id: this.id,
                            email: this.email.toLocaleLowerCase(),
                            language: this.language, 
                            password: this.password,
                            name: this.name,
                            birthday: this.birthday,
                            phone: this.phone, 
                            country: this.country.code,
                            chucheon: this.chucheon,
                            huwon: this.huwon,
                            branch: this.branch.code,
                            center: this.center.code
                        });
                    }
                    this.http.post("register", body).then((res:any)=>{
                        if(res.result == "OK") {
                            let alert = this.alertCtrl.create({
                                message: res.message,
                                buttons: ['OK']
                            });
                            alert.present();
                            if (this.readonly) this.viewCtrl.dismiss('OK');
                            if (!this.readonly) {
                                this.navCtrl.push(EmailauthPage, {
                                    id: this.id,
                                    name: this.name,
                                    birthday: this.birthday,
                                    password: this.password,
                                    email: this.email,
                                    country: this.country.code,
                                    phone: this.phone,
                                    chucheon: this.chucheon,
                                    huwon: this.huwon,
                                    branch: this.branch.code,
                                    center: this.center.code
                                });
                            }
                            this.isEnabledBtn = true;

                        } else if(res.result ==="NOT-AUTH"){
                            let alert = this.alertCtrl.create({
                                message: res.message,
                                buttons: [
                                    {
                                        text: 'OK',
                                        handler: () => {
                                            if (!this.readonly) {
                                                let modal = this.modalCtrl.create(CommonmodalPage);
                                                modal.present();
                                                modal.onDidDismiss( data => {
                                                    this.navCtrl.setRoot(LoginPage);
                                                });
                                            } else if (this.readonly) {
                                                this.viewCtrl.dismiss('OK');
                                            } else {
                                                this.viewCtrl.dismiss();
                                            }
                                        }
                                    }
                                ]
                            });
                            alert.present();
                        
                        } else if(res.result ==="LOGOUT"){
                            let alert = this.alertCtrl.create({
                                message: res.message,
                                buttons: ['OK']
                            });
                            alert.present();
                            localStorage.removeItem("loginId");
                            this.app.getRootNav().setRoot(LoginPage);
                        
                        } else if (res.result === "NO") {
                            this.isEnabledBtn = true;
                            //// 에러메시지를 받았을때 표시한다.
                            let alert = this.alertCtrl.create({
                                message: res.message,
                                buttons: ['OK']
                            });
                            alert.present();
                        } else {
                            this.isEnabledBtn = true;
                            //// 에러메시지를 받았을때 표시한다.
                            let alert = this.alertCtrl.create({
                                message: res.alertM_no,
                                buttons: ['OK']
                            });
                            alert.present();
                        }
                        
                    },(err)=>{
                        this.isEnabledBtn = true;	
                        //// HTTP 에러인 경우
                        let alert = this.alertCtrl.create({
                            message: this.texts.alertM_err,
                            buttons: ['OK']
                        });
                        alert.present();
                        
                    });

                } else {
                    this.isEnabledBtn = true;
                }

            });
        }
    }

    _next() {
        if (this.slides.getActiveIndex() == 0 && this._validate1()) {
			this._slideNext();
            return;
        }

        if (this.slides.getActiveIndex() == 1 && this._validate2()) {
            this._slideNext();
            return;
        }

        if (this.slides.getActiveIndex() == 2 && this._validate3()) {
            this._slideNext();
            return;
        }

        if (this.slides.getActiveIndex() == 3 && this._validate4()) {
            this._slideNext();
            return;
        }
    }
    
    _prev() {
		if (this.slides.getActiveIndex() == 1) {
			this._prev_init();
        }

        if (this.slides.getActiveIndex() == 2) {
            this._prev_init();
		}

        if (this.slides.getActiveIndex() == 3) {
            this._prev_init();
		}

        if (this.slides.getActiveIndex() == 4) {
            this._prev_init();
		}
	}
	
	_prev_init() {
		this.isEnabledBtn = false;    
        this.slides.lockSwipes(false);
        this.slides.slidePrev();
        this.step = this.slides.getActiveIndex() + 1;
		this.isEnabledBtn = true;
		return this.slides.lockSwipes(true);
	}

    _slideNext() {
        this.isEnabledBtn = false; 
        this.slides.lockSwipes(false);
		this.slides.slideNext();  
        this.step = this.slides.getActiveIndex() + 1;
		this.isEnabledBtn = true;
		return this.slides.lockSwipes(true);
    }

    _validate1():boolean {
		this.isId = true;
        this.isPasswordValid = true;
		this.isConfirmPasswordValid = true;

		if (!this.id || this.id.length == 0) {
            this.isId = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_id,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (!this.password || this.password.length == 0) {
            this.isPasswordValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_password,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (!(this.password == this.confirmPassword)) {
            this.isConfirmPasswordValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_comfirm_password,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        // if (this.terms == false) {
		// 	const toast = this.toastCtrl.create({
		// 		message: this.texts.toastM_terms,
		// 		duration: 2000,
		// 		position: 'middle'
		// 	});
		// 	toast.present();
		// 	return ;
		// }

        return this.isId && this.isPasswordValid && this.isConfirmPasswordValid;
    }

    _validate2():boolean {  
        this._birthday();

		this.isNameValid = true;
        this.isBirthdayValid = true;
        this.isBirthdayConfirmValid = true;
        this.isEmailValid = true;
        this.isPhoneValid = true;
		
		if (!this.name || this.name.length == 0) {
            this.isNameValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_name,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (!this.birthday || this.birthday.length == 0) {
            this.isBirthdayValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_birthday,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (this.birthday.length != 10) {
            this.isBirthdayConfirmValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_birthday_confirm,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        

        if (!this.phone || this.phone.length == 0) {
            this.isPhoneValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_phone,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        

        return this.isNameValid && this.isBirthdayValid && this.isBirthdayConfirmValid && this.isPhoneValid;
	}

    _validate3():boolean {
		this.isCountryValid = true;
		this.isBranchValid = true;
		this.isCenterValid = true;
        // this.isCenterValid = true;
        
        if (!this.country || this.country.length == 0) {
            this.isCountryValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_country,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (!this.branch || this.branch.length == 0) {
            this.isCenterValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_branch,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (!this.center || this.center.length == 0) {
            this.isCenterValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_center,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        return this.isCountryValid && this.isBranchValid && this.isCenterValid;
    }

    _validate4():boolean {
		this.isChucheonValid = true;
		this.isEmailValid = true;

        if (!this.chucheon || this.chucheon.length == 0) {
            this.isChucheonValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_chucheon,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        if (!this.email || this.email.length == 0) {
            this.isEmailValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_email,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return ;
        }

        // if (!this.huwon || this.huwon.length == 0) {
        //     this.isHuwonValid = false;
        //     const toast = this.toastCtrl.create({
        //         message: this.texts.toastM_huwon,
        //         duration: 2000,
        //         position: 'middle'
        //     });
        //     toast.present();
        //     return ;
        // }

        return this.isChucheonValid && this.isEmailValid;
    }

    _birthday() {
        if(this.month != "") {
            let tmps_month = this.month;
            this.month = tmps_month.padStart(2, "0");
        }

        if(this.day != "") {
            let tmps_day = this.day;
            this.day = tmps_day.padStart(2, "0");
        }

        if(this.month != "" && this.day != "") {
            this.birthday = this.year + "-" + this.month + "-" + this.day;
        } else {
            this.birthday = ""
        }
    }

    handleChange() {
        let body = JSON.stringify({
            branch: this.branch.code
            });
            this.http.post("common/index/center", body).then((res:any)=>{
                if(res.result=="OK"){
                    this.isDisabled = false;

                    this.center_list = res.center_list;
                    // this.center = this.center_list[0].code;

                } else if(res.result ==="LOGOUT"){
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    localStorage.removeItem("loginId");
                    this.app.getRootNav().setRoot(LoginPage);
                
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            },(err)=>{
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_err,
                    buttons: ['OK']
                });
                alert.present();
            });

    }


    // _validate4():boolean {
	// 	this.isEmailValid = true;
		
	// 	if (!this.email || this.email.length == 0) {
    //         this.isEmailValid = false;
    //         const toast = this.toastCtrl.create({
    //             message: this.texts.toastM_email,
    //             duration: 2000,
    //             position: 'middle'
    //         });
    //         toast.present();
    //         return ;
    //     }

    //     return this.isEmailValid;
    // }
}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts